import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

window.addEventListener('load', () => {
  onElelementExistRunOnce('.fertilizers_new_page, .fertilizers_edit_page', () => {
    import('./internal/fertilizers_new_page__fertilizers_edit_page')
      .then(({ default: Component }) => Component());
  });
});
